<template>
  <b-jumbotron>
    <template slot="header">
      <p style="font-size: 30px; text-align: center;">{{$t('text8')}}</p>
    </template>
    <template slot="lead">
      <p class="text-center">{{$t('text9')}}</p>
      <p class="text-center">{{$t('text10')}}</p>
    </template>
    <hr class="my-4">
    <p class="text-center red-href">
      <b-link :to="{name: 'statistics', params: {type: 'circus'}}">{{$t('circusArtists')}}</b-link><br><br>
      <b-link :to="{name: 'statistics', params: {type: 'dancers'}}">{{$t('dancers')}}</b-link><br><br>
      <b-link :to="{name: 'statistics', params: {type: 'musicians'}}">{{$t('musicians')}}</b-link>
    </p>
  </b-jumbotron>
</template>

<script>
  export default {
    name: "StatStart"
  }
</script>

<style lang="scss" scoped>
  .red-href>a {
    color: #FB404B;
    text-decoration: underline;
  }
</style>
